import React, { useEffect, useRef, useState } from 'react'
import CreatePurchases from '../CreatePurchases/CreatePurchases'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import { isAxiosError } from 'axios'
import { useSelector } from 'react-redux'
import ConfirmModal from '../../components/ConfirmModal/index'
import customMainApi from '../../api/index'

const CreatePurchasesPage = () => {
	const { getMe } = useSelector((state) => state.main)

	const successModalRef = useRef()

	const errorRef = useRef()


	const [itemName, setItemName] = useState('')
	const [batteryLife, setBatteryLife] = useState('')
	const [color, setColor] = useState('')
	const [memory, setMemory] = useState('')
	const [condition, setCondition] = useState('')
	const [btnLoading, setBtnLoading] = useState(false)
	const [userFields, setUserFields] = useState([])
	const [itemGrps, setItemGrps] = useState([])
	const [itemGrp, setItemGrp] = useState([])

	const [series, setSeries] = useState([])
	const [serie, setSerie] = useState('')

	const CreateItemsPost = async () => {
		setBtnLoading(true)

		try {
			await api
				.post(`Items`, {
					// ItemCode: itemCode,
					ItemName: itemName,
					Series: serie,
					ManageBatchNumbers: 'tNO',
					ManageSerialNumbers: 'tYES',
					CostAccountingMethod: 'bis_SNB',
					U_Color: color,
					U_Condition: condition,
					U_Memory: memory,
					ItemsGroupCode: Number(itemGrp),
					// U_BatteryLife: batteryLife,
				})
				.then((res) => {
					successModalRef.current?.open('Пользователь успешно создан')
					return JSON.parse(res.data).value
				})
			// navigation('/purchases')
		} catch (e) {
			if (isAxiosError(e)) {
				errorRef.current?.open(
					get(JSON.parse(e.response.data), 'error.message', ''),
				)
			}
		} finally {
			setBtnLoading(false)
		}
	}

	const getItemSeries = () => {
		api
			.post('SeriesService_GetDocumentSeries', {
				DocumentTypeParams: {
					Document: '4',
				},
			})
			.then((res) => {
				const items = JSON.parse(res.data).value
				const filteredItems = items.filter((item) => item.IsManual === 'tNO')
				console.log(filteredItems)
				setSeries(filteredItems)
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM'",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}
	const getItemGroups = () => {
		customMainApi.get('ItemGroups?$select=Number,GroupName').then((res) => {
			setItemGrps(JSON.parse(res.data).value)
		})
	}

	const handlePostBtnClick = () => {
		CreateItemsPost()
	}

	useEffect(() => {
		console.log(getMe)
		userFieldsFn()
		getItemSeries()
		getItemGroups()
	}, [])

	return (
		<Layout>
			<CreatePurchases>
				<div className="container">
					<div className="overflow-y-auto my-8">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 "></thead>
							<tbody>
								<tr className="bg-white  hover:bg-gray-50 ">
									<td className="px-6 py-4 border">
										<div className="searchable-select">
											<div className={'searchableHead'}>
												<div>
													<p>Наименование товара</p>
													<input
														className={
															'border-[1px] border-[#DFE2E9"] p-1 mt-2 rounded-md w-[300px]'
														}
														type="text"
														onChange={(e) => {
															setItemName(e.target.value)
														}}
														placeholder="Наименование товара"
														value={itemName}
													/>
												</div>
											</div>
										</div>
									</td>
									<td className="px-6 border py-4">
										<p>Группа Товаров</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 w-[100px] rounded-md'
											}
											onChange={(e) => {
												setItemGrp(e.target.value)
											}}
											value={itemGrp}
										>
											<option key={''} value={''}></option>
											{itemGrps.map((item, idx) => (
												<option key={idx} value={item.Number}>
													{item.GroupName}
												</option>
											))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Серия</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 w-[70px] rounded-md'
											}
											onChange={(e) => {
												setSerie(e.target.value)
												console.log(e.target.value)
											}}
											value={serie}
										>
											<option key={''} value={''}></option>
											{series.map((item, idx) => (
												<option key={idx} value={item.Series}>
													{item.Prefix}
												</option>
											))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Состояние</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 w-[100px] rounded-md'
											}
											onChange={(event) => {
												setCondition(event.target.value)
												if (event.target.value === 'NEW') {
													setBatteryLife('100%')
												}
											}}
											value={condition}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Condition')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Цвет</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 w-[100px] rounded-md'
											}
											onChange={(event) => setColor(event.target.value)}
											value={color}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Color')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>

									<td className="px-6 border py-4">
										<p>Память</p>
										<select
											className={
												'border-[1px] border-[#DFE2E9"] p-1 mt-2 w-[100px] rounded-md'
											}
											onChange={(event) => setMemory(event.target.value)}
											value={memory}
										>
											<option value=""> </option>
											{userFields
												?.find((item) => item.Name === 'Memory')
												?.ValidValuesMD.map((value) => (
													<option value={value.Value}>
														{value.Description}
													</option>
												))}
										</select>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div
						style={{
							display: 'flex',
							justifyContent: 'end',
							paddingRight: '50px',
							paddingTop: '30px',
						}}
					>
						<Button isLoading={btnLoading} onClick={handlePostBtnClick}>
							Создать
						</Button>
					</div>
				</div>
			</CreatePurchases>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successModalRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}

export default CreatePurchasesPage